import apiClient from './apiClient';

export const authService = {
  register: (data) =>
    apiClient.post('/api/auth/register', data).then((r) => r.data),

  login: (data) =>
    apiClient.post('/api/auth/login', data).then((r) => r.data),

  refresh: (refreshToken) =>
    apiClient.post('/api/auth/refresh', { refreshToken }).then((r) => r.data),

  logout: () =>
    apiClient.post('/api/auth/logout').then((r) => r.data),

  getMe: () =>
    apiClient.get('/api/auth/me').then((r) => r.data),

  changePassword: (data) =>
    apiClient.patch('/api/auth/change-password', data).then((r) => r.data),
};